/**
 * Actions for the UserIdsToken store
 */

export class UserIdsTokenReset {
  static readonly type = '[UserIdsToken] Reset';
}

export class SetUserIdsToken {
  static readonly type = '[UserIdsToken] Set Token';

  constructor(
    public userIds: string[],
    public companyId: string,
    public token: string,
    public customHash?: string,
  ) { }
}

export class GetUserIdsToken {
  static readonly type = '[UserIdsToken] Get Token';

  constructor(
    public userIds: string[],
    public companyId: string,
    public customHash?: string,
  ) { }
}

export class CleanExpiredTokens {
  static readonly type = '[UserIdsToken] Clean Expired Tokens';
}
